import { useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { NFLookupAccount } from "src/components/Shared/NewForms/NFLookupAccount";
import { NFLookupIncomeItem } from "src/components/Shared/NewForms/NFLookupIncomeItem";
import { NFLookupProduct } from "src/components/Shared/NewForms/NFLookupProduct";
import { NFLookupUnit } from "src/components/Shared/NewForms/NFLookupUnit";
import { NFPlainNumber } from "src/components/Shared/NewForms/NFPlainNumber";
import { NFPlainText } from "src/components/Shared/NewForms/NFPlainText";
import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import { AmountHelper } from "src/helpers/AmountHelper";
import { DocumentCalculationsHelper } from "src/helpers/DocumentCalculationsHelper";

export const PostingOfGoodsDetailProducts = () => {
  const tableName = "products";
  const { setValue, getValues, watch } = useFormContext();
  const { t } = useTranslation();

  const handleQuantityChanged = (newQuantity: number, index: number) => {
    const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
      newQuantity,
      getValues(`${tableName}.${index}.price`),
      getValues(`${tableName}.${index}.vatType`),
      getValues("priceIncludesVat")
    );
    setValue(`${tableName}.${index}.amount`, newAmounts.amount);
    setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
    setValue(`${tableName}.${index}.amountWithVat`, newAmounts.amountWithVat);
  };

  const handlePriceChanged = (newPrice: number, index: number) => {
    const newAmounts = AmountHelper.getNewAmountsAfterQuantityPriceChanged(
      getValues(`${tableName}.${index}.quantity`),
      newPrice,
      getValues(`${tableName}.${index}.vatType`),
      getValues("priceIncludesVat")
    );
    setValue(`${tableName}.${index}.amount`, newAmounts.amount);
    setValue(`${tableName}.${index}.vatAmount`, newAmounts.vatAmount);
    setValue(`${tableName}.${index}.amountWithVat`, newAmounts.amountWithVat);
  };

  useEffect(() => {}, [watch("products")]);

  const handleAmountChanged = () => {
    setValue("totalAmount", DocumentCalculationsHelper.calculateTotalAmount(getValues("products"), "amount"));
  };

  return (
    <>
      <NFormTable fieldArray={tableName}>
        <NFPlainNumber fieldName={"lineNo"} title={t("#")} width={50} />
        <NFLookupProduct fieldName={"productId"} title={t("Product")} width={200} />
        <NFPlainText fieldName={"vendorCode"} title={t("VendorCode")} width={100} />
        <NFLookupUnit fieldName={"unitId"} title={t("Unit")} width={200} />
        <NFIntInput fieldName={"quantity"} title={t("Quantity")} onValueChanged={handleQuantityChanged} width={100} />
        <NFIntInput fieldName={"price"} title={t("Price")} onValueChanged={handlePriceChanged} width={100} />
        <NFIntInput fieldName={"amount"} title={t("Amount")} width={100} onValueChanged={handleAmountChanged} />
        <NFLookupAccount fieldName={"accountId"} title={t("Account")} width={200} />
        <NFLookupIncomeItem fieldName={"incomeItemId"} title={t("IncomeItem")} width={200} />
      </NFormTable>
    </>
  );
};
